import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import NetworkCreateDialog from 'routes/Network/containers/NetworkCreateDialog';
import IRIBufferingEdit from './containers/IRIBufferingEdit';
import IRIBufferingView from './containers/IRIBufferingView';
import { SYSTEM, SYSTEM_CONFIGURATION_ROUTE, IRI_BUFFERING_ROUTE } from '../../constants';

interface Props {
}

const IRIBuffering: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${IRI_BUFFERING_ROUTE}/edit`}>
        <IRIBufferingEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${IRI_BUFFERING_ROUTE}`}>
        <IRIBufferingView />
      </Route>
      <NetworkCreateDialog />
    </Fragment>
  );
};

export default IRIBuffering;
